import { render, staticRenderFns } from "./MapsContent.vue?vue&type=template&id=36a047d1&"
import script from "./MapsContent.vue?vue&type=script&lang=ts&"
export * from "./MapsContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports